import { render } from "./SendListDone.vue?vue&type=template&id=9f4cee90&scoped=true"
import script from "./SendListDone.vue?vue&type=script&lang=js"
export * from "./SendListDone.vue?vue&type=script&lang=js"

import "./SendListDone.vue?vue&type=style&index=0&id=9f4cee90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4cee90"]])

export default __exports__